import { useCallback, useEffect, useState } from 'react'
import { request } from './api'

export default function useResource(path, params = {}, enabled = true, refreshKey = 0) {
  const paramsKey = JSON.stringify(params)
  const [state, setState] = useState({ data: null, loading: enabled, error: null })
  const [version, setVersion] = useState(0)
  const retry = useCallback(() => setVersion((value) => value + 1), [])

  useEffect(() => {
    if (!enabled || !path) {
      setState({ data: null, loading: false, error: null })
      return undefined
    }
    const controller = new AbortController()
    setState((current) => ({ ...current, loading: true, error: null }))
    request(path, { params: JSON.parse(paramsKey), signal: controller.signal })
      .then((data) => setState({ data, loading: false, error: null }))
      .catch((error) => {
        if (error.name !== 'AbortError') setState({ data: null, loading: false, error })
      })
    return () => controller.abort()
  }, [enabled, paramsKey, path, refreshKey, version])

  return { ...state, retry }
}
